import store from '@/state/store'

export const federatedLoginGuard = async (to) => {
  if (store.getters['auth/loggedIn']) {
    return { path: '/' }
  }

  try {
    const authService = await import('@/services/auth.service')
    const data = await authService.getFedIdUrlV2()

    const targetUrl = data?.url || data?.data?.url

    if (targetUrl) {
      window.location.href = targetUrl
    }
  } catch (error) {
    console.error('Federated Login Error:', error)
  }
}
